/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import {
  ProfileRewardsOverview,
  ProfileRewardsState,
} from '../types/profileRewards';
import { fetchProfileRewardsOverview } from '../actions/profileRewards';

const initialState: ProfileRewardsState = {
  overview: null,
  isFetching: false,
  lastReward: null,
};

const profileRewardsSlice = createSlice({
  name: 'profileRewards',
  initialState,
  reducers: {
    clearLastReward: (state) => {
      state.lastReward = null;
    },
    /**
     * Flips verification to in-review the moment the document is submitted, so
     * every surface reading `verification_state` updates without waiting for the
     * overview refetch (or a reload) to catch up.
     */
    setVerificationInReview: (state) => {
      if (state.overview) {
        state.overview.verification_state = 'in_review';
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfileRewardsOverview.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(fetchProfileRewardsOverview.fulfilled, (state, action) => {
        state.isFetching = false;
        state.overview = action.payload as ProfileRewardsOverview;
        // Credits are auto-granted server-side and reported in newly_granted; if
        // anything landed this fetch, celebrate it once.
        const granted = action.payload.newly_granted ?? [];
        if (granted.length) {
          state.lastReward = {
            amount: granted.reduce((sum, g) => sum + (g.amount ?? 0), 0),
            balance: action.payload.credits?.balance ?? 0,
          };
        }
      })
      .addCase(fetchProfileRewardsOverview.rejected, (state) => {
        state.isFetching = false;
      });
  },
});

export const { clearLastReward, setVerificationInReview } =
  profileRewardsSlice.actions;
export default profileRewardsSlice.reducer;
